import { getData } from "./getData";
import { Post } from "@/wp/types/client";

export async function getVideoData({
  videoId,
  fields,
  locale,
  defaultLocale,
}: {
  videoId: string;
  fields?: string;
  locale?: string;
  defaultLocale?: string;
}): Promise<Post<"videos"> | null> {
  const url =
    "/videos/" +
    videoId +
    "?_fields=" +
    (fields ? `${fields}` : "acf.header_videos,link");
  const response = await getData(url, locale, defaultLocale);
  if (!response) {
    throw new Error(`Video with ID ${videoId} not found`);
  }
  return response as Post<"videos">;
}
